exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrapper___hnQSd{\n  position:relative;\n  display:flex;\n  align-items:center;\n  height: 64px;\n}", ""]);

// Exports
exports.locals = {
	"wrapper": "wrapper___hnQSd"
};